<mosaic-detail
  [unidadMedida]="unidadMedida"
  [language]="language"
  (onSelectStock)="selectStockItem($event)"
  [stock]="stock"
  [hasSimilar]="!!materialesSimilares.length"
  [maestros]="maestros">
</mosaic-detail>
<image-carousel class="col-" *ngIf="materialesSimilares.length" [items]="materialesSimilares"></image-carousel>
<div (click)="goBack()" class="back"><img src="assets/img-svg/left-arrow.svg"></div>
